import numberGuess from '../../../img/numberguess.png';
import './Projectleftimage.css';

const ProjectImage = () => {
  return (
    <img 
      src={numberGuess} 
      alt="Number Guessing Game application" 
      className="photossss reveal fade-left" 
    />
  );
};

export default ProjectImage;
